export default __webpack_public_path__ + "static/media/tq.84d25a1e.jpg";